import { SortDirection as KnowledgeSortDirection } from "@redotech/cockroachdb-codegen/congodb/sort-direction";
import * as z from "zod";

// How a merchant-facing knowledge list is ordered. Each corpus names the
// columns it can order by, so a key that no query can honor cannot be asked
// for.

export enum ManagedKnowledgeSortKey {
  Created = "created",
  Uses = "uses",
}

export const managedKnowledgeSortSchema = z.object({
  key: z.enum(ManagedKnowledgeSortKey),
  direction: z.enum(KnowledgeSortDirection),
});
export type ManagedKnowledgeSort = z.infer<typeof managedKnowledgeSortSchema>;

export enum ProductKnowledgeSortKey {
  Created = "created",
}

export const productKnowledgeSortSchema = z.object({
  key: z.enum(ProductKnowledgeSortKey),
  direction: z.enum(KnowledgeSortDirection),
});
export type ProductKnowledgeSort = z.infer<typeof productKnowledgeSortSchema>;
